import { Button, Modal, Form, Row, Col, Input, message, Checkbox } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { handleCreateDealTitle } from "../../../../api/dealTitles";

export default function CreateDealTitle({ isVisible, setVisible }: any) {
  const [isActive, setActive] = useState<boolean>(true);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleCreateDealTitle,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["dealTitles"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { title } = await form.getFieldsValue();
    const data = {
      title,
      isActive,
    };
    await mutate(data);
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Create Deal Title"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createDealTitle"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createDealTitle"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="title"
              label="Deal Title"
              rules={[
                {
                  required: true,
                  message: "Please enter deal title",
                },
              ]}
            >
              <Input type="" placeholder="Deal Title" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Checkbox
              onChange={(e: any) => {
                setActive(e.target.checked);
              }}
              defaultChecked={isActive}
            >
              Is Active
            </Checkbox>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
